module.exports = __webpack_public_path__ + "img/joodskindermonument_alleenmonument_600x600px.45f5f68d.png";